module.exports = __webpack_public_path__ + "static/img/interview-coaching.978d216.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/specialist/interview-coaching.png
// module id = 8t4P
// module chunks = 1